import React, { ReactElement, useContext } from 'react';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import classnames from 'classnames';
import { Flex } from 'components/Flex/Flex';
import { Spacer } from 'components/Spacer/Spacer';
import styles from './TableLegend.module.scss';

export const TableLegend = (): ReactElement => {
  const { client } = useContext(WidgetGeneratorContext);

  return (
    <Flex flexDirection="column">
      <Flex flexDirection="row" alignItems="center">
        <div className={classnames(styles.shape, styles.circle)} />
        <Spacer orientation="horizontal" size="xsmall" />
        <span className={styles.legendText}>{client.name}</span>
      </Flex>
      <Spacer orientation="vertical" size="small" />
      <Flex flexDirection="row" alignItems="center">
        <div className={classnames(styles.shape, styles.square)} />
        <Spacer orientation="horizontal" size="xsmall" />
        <span className={styles.legendText}>Cohort</span>
      </Flex>
      <Spacer orientation="vertical" size="small" />
      <Flex flexDirection="row" alignItems="center">
        <div className={classnames(styles.shape, styles.triangle)} />
        <Spacer orientation="horizontal" size="xsmall" />
        <span className={styles.legendText}>National</span>
      </Flex>
    </Flex>
  );
};
